export default __webpack_public_path__ + "static/media/loha-web1.85936414.jpg";